import { createContext } from "preact";
import { useContext } from "preact/hooks";
import type { RollOptions, RollRequest } from "./rolls";

export interface OpenEntryOptions {
  /** The rank a spell is cast at, for `@item.rank` in its description. */
  rank?: number | undefined;
  /** A Condition's value or an Effect's counter, for `@item.badge.value`. */
  badge?: number | undefined;
}

/** What any tab can ask the Character page for: open an Entry in the viewer, make a Roll. */
export interface SheetActions {
  openEntry(uuid: string, options?: OpenEntryOptions): void;
  /** Make a Roll; `physical` asks for the dice to be entered by hand (a long press). */
  roll(request: RollRequest, options?: RollOptions): void;
}

export const SheetContext = createContext<SheetActions>({ openEntry: () => undefined, roll: () => undefined });

export function useSheetActions(): SheetActions {
  return useContext(SheetContext);
}
